import React, { useMemo } from 'react';
import { INSTITUTION_IMAGES } from 'Constants';
import { Button, QuickTypes } from 'Views/Components/Button/Button';
import { useHistory } from 'react-router';
import AutoSaveStatusLabel from 'Views/Components/AutoSaveHeader/AutoSaveStatusLabel';

interface IAutoSaveHeader {
	showLogo?: boolean;
	title?: string;
	autoSaveStatus?: SAVE_STATUS;
	saveStatus?: SAVE_STATUS;
	saveOnExit?: () => void;
	exitButtonLabel?: string;
	disabledExitButton?: boolean;
}

export enum SAVE_STATUS {
	UNSAVED = 'unsaved',
	SAVING = 'saving',
	SAVED = 'saved',
}

const AutoSaveHeader = ({
	showLogo = false,
	title,
	autoSaveStatus,
	saveStatus,
	saveOnExit,
	disabledExitButton,
}: IAutoSaveHeader) => {
	const history = useHistory();

	const isSaving = useMemo(
		() => autoSaveStatus === SAVE_STATUS.SAVING || saveStatus === SAVE_STATUS.SAVING,
		[autoSaveStatus, saveStatus],
	);

	const isSaved = useMemo(
		() => autoSaveStatus === SAVE_STATUS.SAVED || saveStatus === SAVE_STATUS.SAVED,
		[autoSaveStatus, saveStatus],
	);

	const exitButtonLabel = saveOnExit
		? 'Save & Exit'
		: 'Exit';

	return (
		<div className="autosave-header">
			<div className="left">
				{
					showLogo
						? (
							<div className="institute-logo">
								<img
									src={INSTITUTION_IMAGES.LOGO}
									className="institute-logo"
									alt="institute-logo"
								/>
							</div>
						)
						: null
				}
				{
					title
						? (
							<div className="title">
								{title}
							</div>
						)
						: null
				}
			</div>
			<div className="right">
				<AutoSaveStatusLabel isSaving={isSaving} isSaved={isSaved} />
				<Button
					onClick={saveOnExit || (() => history.goBack())}
					disabled={disabledExitButton || saveStatus === SAVE_STATUS.SAVING}
					quickTypes={QuickTypes.Secondary}
				>
					{exitButtonLabel}
				</Button>
			</div>
		</div>
	);
};

export default AutoSaveHeader;
